import React from 'react';
import PropTypes from 'prop-types';

// material-ui components
import { withStyles } from '@material-ui/core/styles';

import badgeStyle from './styles.jsx';

function Badge({ ...props }) {
    const { classes, color, children } = props;
    return (
        <span className={ classes.badge + ' ' + classes[color] }>{ children }</span>
    );
}

Badge.propTypes = {
    classes: PropTypes.object.isRequired,
    color: PropTypes.oneOf([
        'primary',
        'warning',
        'danger',
        'success',
        'info',
        'rose',
        'gray',
    ]),
    children: PropTypes.any,
};

export default withStyles(badgeStyle)(Badge);



// WEBPACK FOOTER //
// ./src/common/Badge/Badge.jsx